module.exports = __webpack_public_path__ + "assets/img/w_d_i_4.e8af2368.jpg";